import { render, staticRenderFns } from "./AddNewVacation.vue?vue&type=template&id=e61dbac4&scoped=true&"
import script from "./AddNewVacation.vue?vue&type=script&lang=ts&"
export * from "./AddNewVacation.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewVacation.vue?vue&type=style&index=0&id=e61dbac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61dbac4",
  null
  
)

component.options.__file = "AddNewVacation.vue"
export default component.exports